@if (isCustomerEmulationSessionInProgress$ | async) {
<span class="material-icons" inline="true">info_outline</span>
<span
  [innerHtml]="
    'dealer.successMessage'
      | cxTranslate
        : {
            company: b2bunitEnabled === 'true' ? emulatedCompany : customer?.orgUnit?.name || customer?.company,
            customer:
              (customer?.firstName || customer?.lastName) && customer?.lastName !== undefined
                ? customer?.firstName + ' ' + customer?.lastName
                : customer?.name || customer?.email
          }
  "
></span>
}
